import { render, staticRenderFns } from "./callTestDialog.vue?vue&type=template&id=54b7da20&scoped=true&"
import script from "./callTestDialog.vue?vue&type=script&lang=js&"
export * from "./callTestDialog.vue?vue&type=script&lang=js&"
import style0 from "./callTestDialog.vue?vue&type=style&index=0&id=54b7da20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b7da20",
  null
  
)

export default component.exports